export enum ReportStatusEnum {
    GenerationInProgress = 1,
    Generated = 2,
    Downloaded = 3
  }